import clsx from 'clsx';
import React from 'react';
import { useFlexAssessmentContext } from '../context/context';
import styles from '../css/header.module.scss';
import { ReactComponent as Logo } from '../media/pivot-flex-logo.svg';

const Header = React.memo(() => {
  const { state } = useFlexAssessmentContext();
  const orgLogoUrl: string = state?.orgConfig?.logoUrl ?? '';

  return (
    <header
      className={clsx(styles.header, { [styles.hasOrgLogo]: orgLogoUrl })}
    >
      {orgLogoUrl ? (
        <img src={orgLogoUrl} alt="" className={styles.orgLogo} />
      ) : (
        <Logo />
      )}
    </header>
  );
});

export default Header;
